exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.soc-togo-sub[data-v-7afdc711] {\r\n  margin: 0 0 12px;\r\n  color: var(--sap-text-secondary, #5b616b);\r\n  font-size: 13px;\n}\n.soc-togo-hint[data-v-7afdc711] {\r\n  margin: 12px 0 0;\r\n  font-size: 12px;\r\n  color: #64748b;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7afdc711","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SocWorkOrderTogoDialog.vue
// module id = F8s9
// module chunks = 492